import { Grid, Stack, Typography } from "@mui/material";
import { useAppSelector } from "../../../store";
import AddIcon from "@mui/icons-material/Add";
import { useContext } from "react";
import { AmbassadorProfileContext } from ".";
import { ButtonMotion } from "../../../components/form/buttons";
import { APP_COLORS } from "../../../enums";
import { DefaultButton, EditButton, PrimaryButton } from "../../../components/form";

export default function MyProfileSectionTitle({
  title,
  subtitle,
  onEditClick,
  onAddClick,
  props,
  operation = "EDIT",
}: any) {
  const { editMode } = useAppSelector((state) => state.profile);
  const userData = useAppSelector((state) => state.auth.user);
  const { data } = useContext(AmbassadorProfileContext);

  return (
    <Grid
      item
      xs={12}
      container
      alignItems={"center"}
      justifyContent={"space-between"}
      borderBottom={1}
      borderColor={APP_COLORS.greyLight3}
      pb={1}
    >
      <Stack>
        <Typography
          variant="bodyLarge-mono-medium"
          color={APP_COLORS.textDark}
          {...props}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body-ibmPlexMono" color={APP_COLORS.textLight2}>
            {subtitle}
          </Typography>
        )}
      </Stack>

      {userData?.profileId && userData?.profileId === data?.id && (
        <ButtonMotion>
          {operation === "EDIT" && (
            <EditButton
              sx={{ visibility: editMode ? "visible" : "hidden" }}
              onClick={onEditClick}
              size="small"
            />
          )}

          {operation === "ADD" && (
            <PrimaryButton
              sx={{ visibility: editMode ? "visible" : "hidden" }}
              onClick={onAddClick}
              size="small"
              startIcon={<AddIcon />}
            >
              Add
            </PrimaryButton>
          )}
        </ButtonMotion>
      )}
    </Grid>
  );
}
